// src/components/ui/PasswordStrengthBar.jsx
// Barra visual de força de senha. Avalia entropia simples por classes de caracteres + comprimento.
// Não bloqueia, apenas informa.
import React, { useMemo } from "react";

function avaliarForca(senha) {
  const s = String(senha || "");
  if (!s) return { nivel: 0, label: "—", cor: "#E2E8F0", textoCor: "#94A3B8" };

  let pontos = 0;
  if (s.length >= 6) pontos += 1;
  if (s.length >= 8) pontos += 1;
  if (s.length >= 12) pontos += 1;
  if (/[a-z]/.test(s)) pontos += 1;
  if (/[A-Z]/.test(s)) pontos += 1;
  if (/\d/.test(s)) pontos += 1;
  if (/[^A-Za-z0-9]/.test(s)) pontos += 1;

  // Penalizações
  if (/^(\d+|[a-zA-Z]+)$/.test(s)) pontos -= 1; // só letras OU só números
  if (/^(.)\1+$/.test(s)) pontos = 0; // todos iguais
  if (/^(123|abc|qwer|senha|password|admin)/i.test(s)) pontos = Math.min(pontos, 1);

  pontos = Math.max(0, Math.min(pontos, 7));

  if (pontos <= 1) return { nivel: 1, label: "Muito fraca", cor: "#EF4444", textoCor: "#991B1B" };
  if (pontos <= 3) return { nivel: 2, label: "Fraca",       cor: "#F59E0B", textoCor: "#92400E" };
  if (pontos <= 5) return { nivel: 3, label: "Boa",         cor: "#3B82F6", textoCor: "#1D4ED8" };
  return            { nivel: 4, label: "Forte",       cor: "#10B981", textoCor: "#065F46" };
}

export default function PasswordStrengthBar({ senha, dicas = true }) {
  const { nivel, label, cor, textoCor } = useMemo(() => avaliarForca(senha), [senha]);
  const segmentos = [1, 2, 3, 4];

  return (
    <div style={{ marginTop: 6 }}>
      <div style={{ display: "flex", gap: 4 }}>
        {segmentos.map((i) => (
          <div
            key={i}
            style={{
              flex: 1,
              height: 4,
              borderRadius: 2,
              background: i <= nivel ? cor : "#E2E8F0",
              transition: "background .2s",
            }}
          />
        ))}
      </div>
      <div
        style={{
          marginTop: 4,
          fontSize: 11,
          fontWeight: 600,
          color: senha ? textoCor : "#94A3B8",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>
          Força: <span style={{ color: textoCor }}>{label}</span>
        </span>
        {dicas && senha && nivel < 3 && (
          <span style={{ color:"var(--gray-500)", fontWeight: 400 }}>
            Dica: combine letras, números e símbolos.
          </span>
        )}
      </div>
    </div>
  );
}
